import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Control, Form, actions } from 'react-redux-form';

import Button from '../../Button';
import BaseDetailScreen from '../../BaseDetailScreen';
import LabeledRow from '../components/LabeledRow';
import {
  PLACEHOLDER_OPT,
  offerOrderAmountPath,
  offerOrderTransferPath,
} from '../../Forms/Schemas/baseRrf';
import Select, { SELECT_STYLE } from '../../Forms/Controls/Select';
import InputField from '../../Forms/Controls/Field';
import CurrencyField from '../../Forms/Controls/CurrencyField';
import Currency, { formatCurrency } from '../../Currency';
import Tooltip from '../../Tooltip';
import { myIPOAccountID, getAccountOptsFromBankLinks } from '../../TransferFunds/utils';
import BankInfo from '../../SignUp/BankInfo';
import { filterActiveBankLinks } from '../../../helpers/filterActiveBankLink';
import {
  fetchAccountBankLinks,
} from '../../../actions/bankLinks';

import './styles.css';

const Big = require('big.js/big.js');


class OrderPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transferOpts: {},
    };
  }

  componentDidMount() {
    const bigBalance = new Big(this.props.cashBalance).round(2, 0);
    const bigAmount = new Big(this.props.requestedDollarAmount).round(2, 0);
    const bigTransfers = new Big(this.props.pendingTransfers).round(2, 0);
    if (bigBalance.plus(bigTransfers).gte(bigAmount)) {
      this.props.onNext();
    }

    this.props.fetchAccountBankLinks(this.props.accountNumber);
  }

  componentWillReceiveProps = (nextProps) => {
    const { accountBankLinks } = nextProps;
    const newOpts = getAccountOptsFromBankLinks(accountBankLinks);

    // remove My IPO from the available options
    delete newOpts[myIPOAccountID];
    // if account is deleted after already being selected for order
    // then this resets value to PLACEHOLDER_OPT
    if (this.props.offerOrderForm.offerOrderTransferFunds.from &&
     !newOpts[this.props.offerOrderForm.offerOrderTransferFunds.from]) {
      this.props.resetTransferAccount(PLACEHOLDER_OPT);
    }

    this.setState({
      transferOpts: {
        ...newOpts,
      },
    });
  }

  render() {
    const bigAmount = new Big(this.props.requestedDollarAmount).round(2, 0);
    const bigBalance = new Big(this.props.cashBalance).round(2, 0);
    const bigTransfers = new Big(this.props.pendingTransfers).round(2, 0);

    const orderDifference = bigAmount.minus(bigBalance).minus(bigTransfers);
    const orderDiffCurrency = formatCurrency(Number.parseFloat(orderDifference.toString(), 10));
    const accountSelectionField = {
      model: '.from',
      RRFComp: Control,
      control: {
        component: Select,
        selectStyle: SELECT_STYLE.BLUE,
        errors: {
          required: val => !val || !val.length || val === PLACEHOLDER_OPT,
        },
      },
      error: {
        messages: {
          required: 'Please select an account to transfer from.',
        },
      },
    };

    const transferAmountField = {
      model: '.transferAmount',
      RRFComp: Control,
      control: {
        component: CurrencyField,
        parser: val => val && val.toString().replace(/\$|,/g, ''),
        placeholder: '$0.00',
        errors: {
          required: val => !val || !val.length,
          satisfiesOrder: val => val && (orderDifference.gt(val)),
        },
      },
      error: {
        messages: {
          required: 'Please enter the amount to be transferred.',
          satisfiesOrder: `The transfer amount must be at least ${orderDiffCurrency}`,
        },
      },
    };

    const cashAvailableLabel = (
      <div styleName="cashAvailableLabel">
        <span>Cash Available</span>
        <Tooltip
          styles={{ display: 'inline-block', marginLeft: '8px' }}
          text="Cash available is the sum of your cash balance and pending transfers"
        />
      </div>
    );

    const { accountBankLinks, accountNumber } = this.props;
    const { bankLinks, hasDeletedBankLinks } = filterActiveBankLinks(accountBankLinks);
    const bankLinkButton = (
      <BaseDetailScreen
        isBankLink
        backLabel="Review Disclosures"
        backTo={`/invest/${this.props.offer.id}/disclosures`}
        pageHeading="Order Payment Details"
        pageSubheading="The requested order amount requires you to transfer funds into your account."
      >
        <div styleName="main">
          <BankInfo accountNumber={accountNumber} isSignUp={false} onNext={() => {}} />
        </div>
      </BaseDetailScreen>
    );
    const bankLinkMessage = (
      <div styleName="noLinksComment main">
        <span>
          For security purposes we are temporarily restricting bank link management. Please&nbsp;
        </span>
        <a href="mailto:clientservices@myipo.com" styleName="contactLink">
          contact a MyIPO representative
        </a>
        <span>
          &nbsp;to add a new bank link to your account.
        </span>
      </div>
    );

    let content = (
      <BaseDetailScreen
        backLabel="Review Disclosures"
        backTo={`/invest/${this.props.offer.id}/disclosures`}
        pageHeading="Order Payment Details"
        pageSubheading="The requested order amount requires you to transfer funds into your account."
      >
        <div styleName="main">
          <LabeledRow
            isCurrency
            label="Order Amount"
            value={Number.parseFloat(this.props.requestedDollarAmount, 10)}
          />
          <LabeledRow
            isCurrency
            label={cashAvailableLabel}
            value={
              (Number.parseFloat(this.props.cashBalance, 10) +
                Number.parseFloat(this.props.pendingTransfers, 10))}
          />
          <div styleName="breakLine" />
          <Form
            model={offerOrderTransferPath}
            onSubmit={this.props.onNext}
            disabled={this.props.bankLinksFetching}
          >
            <div styleName="fromLabel">
              From
            </div>
            <InputField
              key={accountSelectionField.model}
              fieldProps={accountSelectionField}
            >
              {Object.keys(this.state.transferOpts).sort(a => (
                a === PLACEHOLDER_OPT ? -1 : 1)).map(key => (
                  <option key={key} value={key}>
                    {this.state.transferOpts[key]}
                  </option>
              ))}
            </InputField>
            <div styleName="transferLabel">Transfer Amount</div>
            <InputField
              key={transferAmountField.model}
              fieldProps={transferAmountField}
            />
            <div styleName="cashAvailableRow">
              <div styleName="cashAvailable">
                Additional Funds Required
              </div>
              <Currency
                styleName="cashAvailable"
                amount={Number.parseFloat(orderDifference)}
              />
            </div>
            <div styleName="submitButtonContainer">
              <Button type="submit">
                Review Order
              </Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
    if (bankLinks.length === 0) {
      content = (!hasDeletedBankLinks ? bankLinkButton : bankLinkMessage);
    }
    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  accountBankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  bankLinksFetching: get(state, `acccountBankLinks.[${state.currentAccount}].isFetching`, false),
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades', 0.00)),
  pendingTransfers: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.pendingTransfersAvailableForOfferings')),
  requestedDollarAmount: get(state, `${offerOrderAmountPath}.requestedDollarAmount`),
});

const mapDispatchToProps = dispatch => ({
  fetchAccountBankLinks: (...args) => (dispatch(fetchAccountBankLinks(...args))),
  resetTransferAccount: defaultAccount => (dispatch(actions.change(`${offerOrderTransferPath}.from`, defaultAccount))),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderPayment);



// WEBPACK FOOTER //
// ./src/components/Invest/InvestmentViews/OrderPayment.js